import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// master-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  async getDashboardInfo (store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
        }
      ]
    }
    var response = await Vue.http.post(URL + '/v2/admin/corporation/detail', data, config)

    // 成功後の処理
    store.commit('setDashboardInfo', response)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboardModules/actions.js